import React from "react";
import styled from "styled-components";
import KakaoShareButtonT from "./KakaoShareButtonT";
import StartButton from "./StartButton";

interface Props {
  onClickNext: () => void;
}

const TypingScreen = ({ onClickNext }: Props) => {
  return (
    <Container>
      <Title>나락 퀴즈</Title>

      <Content>
        <TypingText animation="typing1" step={25}>
          본 퀴즈를 누군가 앞에서 풀게되면 공격을 받고
        </TypingText>

        <TypingText animation="typing2" delay={3} step={20}>
          지위나 직업을 박탈당할 수 있습니다.
        </TypingText>

        <TypingText animation="typing3" delay={6} step={17} $last>
          즉, 나락에 가실 수 있습니다.
        </TypingText>
      </Content>

      <StartButton delay={9.5} onClick={() => onClickNext()} />
      <br />
      <KakaoShareButtonT />
    </Container>
  );
};

export default TypingScreen;

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 100px);

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

const TypingText = styled.div<{
  animation: string;
  delay?: number;
  step: number;
  $last?: boolean;
}>`
  font-family: "GangwonEduHyeonokT_OTFMediumA";
  font-size: 24px;
  color: white;
  border-right: 0.15em solid transparent;
  width: 0;
  animation: ${({ animation }) => animation} 3s steps(${({ step }) => step}),
    blink-caret 0.5s step-end ${({ $last }) => ($last ? "infinite" : 6)};
  animation-delay: ${({ delay }) => `${delay}s`};
  animation-fill-mode: forwards;

  white-space: nowrap;
  overflow: hidden;

  /* border-right: 1px solid white; */

  @keyframes typing1 {
    from {
      width: 0;
    }

    to {
      width: 298.375px;
    }
  }

  @keyframes typing2 {
    from {
      width: 0;
    }

    to {
      width: 242.734px;
    }
  }

  @keyframes typing3 {
    from {
      width: 0;
    }

    to {
      width: 185.5px;
    }
  }

  /* The typewriter cursor effect */
  @keyframes blink-caret {
    from,
    to {
      border-color: transparent;
    }
    50% {
      border-color: orange;
    }
  }
`;

const Title = styled.div`
  background: linear-gradient(#f56565 0%, #4f0000 100%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  font-family: "KBO-Dia-Gothic_bold";
  font-size: 40px;
  font-weight: 600;
  /* text-shadow: -1px 0 red, 0 1px red, 1px 0 red, 0 -1px red; */

  margin-bottom: 20px;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  margin-bottom: 20px;
`;
